//  <FileHeader xmlns="http://www.gordic.cz/shared/file-header/v_1.0.0.0">
//    <Name>        Gordic.Adm.WebControls.SeznamAdmUmisteniDesigner.ts             </Name>
//    <Description>                                                             </Description>
//    <Author>      JKLUSACEK                                                      </Author>
//    <Copyright>   � GORDIC spol. s r. o. 1993-2021                            </Copyright>
//    <Created>     2021-10-04                      </Created>
//  </FileHeader>

//This source code was auto-generated by ADT03-Generator, Version=486.16.5
//AdtGeneratorConfig:[ T:(sslsump) GID:(Web.Set.Des.Ts) V1:(umisteni,umisteni_nad,aktivita,poznamka,dat_zmena,zmenu_prov,umisteni_txt,priz_oper,ixs_fun_zodp,budova_kod,segment_kod,mistnost_kod) V2:() K1:() K2:() K3:() ]


/// <reference path="../../Base/SeznamBase.ts" />

namespace Gordic.Adm.WebControls {

    /**
     * SeznamAdmUmisteniDesigner
     * 
     * @author JKLUSACEK
     * @since 482.1.0.119
     */
    export class SeznamAdmUmisteniDesigner extends SeznamBase {

        /** z detail okna p�edan� atribut pro filtr seznamu */
            /** PK - umisteni */
            public umisteni: string;

        /** isl view gridu */
        view: Gordic.Isl.View<Gordic.AdmIsl.Interface.GAdmUmisteniListDto>;

        /** vytvo�it formul�� filtru - panel */
        static createFilter(that: GContentType<SeznamAdmUmisteniDesigner>, umisteni: string  ): JQuery<HTMLElement> {
            // vytvorim form a na nem policka
            let v_form = this.createFilterForm(that, umisteni);
            // vytvorim panel a umistim jej do hlavniho DIVu
            let v_filter = SeznamBase.createFilterBase(that, v_form, true, this.applyAction );

            //v_filter.gfilterpanel("applyFilter");         // toto vede k okam�it�mu na�ten� dat do seznamu podle nastaven�ho filtru

            return (v_filter);
        } // createFilter

        /** vytvo�it formul�� filtru - vytvo�� tam filtra�n� pol��ka */
        static createFilterForm(that: GContentType<SeznamAdmUmisteniDesigner>, umisteni: string ): Forms.Form {

            // vytvo��m form
            var v_filterForm = SeznamBase.createFilterFormBase(that);

            // p�id�m do n�j pol��ka

            return v_filterForm;
        } // createFilterForm

        static applyAction(that: GContentType<SeznamAdmUmisteniDesigner>, ev, ctx): any {
            var filterObj = {
            }
            that.view = new Gordic.Isl.View(that.isl.AdmUmisteni.list({ filters: filterObj }));
            that.grid.ggrid("setData", that.view);
        }

        /**
         * SeznamAdmUmisteniDesignerInit
         * 
         * @param {GContentType<SeznamAdmUmisteniDesigner>} that
         */
        static SeznamAdmUmisteniDesignerInit(that: GContentType<SeznamAdmUmisteniDesigner>, umisteni: string, withFilterPanel: boolean) {
            this.SeznamBaseInit(that);
            if (withFilterPanel == true)
                that.filter = this.createFilter(that, umisteni);
            that.gridFormat = this.createGridFormatByDataListDescription(that);
            that.gridSearchColumns = this.createGridSearchColumnsByDataListDescription(that);
            this.LoadData(that, umisteni);

        } // SeznamAdmUmisteniDesignerInit

        static LoadData(that: GContentType<SeznamAdmUmisteniDesigner>, umisteni: string) {
            var filterObj: any = {}
            that.view = new Gordic.Isl.View(that.isl.AdmUmisteni.list({ filters: filterObj }), { filterPanel: that.filter, startEmpty: false, });
        }

    }
}
